<template>
	<div class="log" >
		<div class="login">
			<div class="login-top">
				<img :src="logo" />
			</div>
			<div class="purchase" v-text="qycgtitle"></div>
			<div class="login-box">	
				<div class="ttshop_singcon">
					
					<div class="ttshop_singconter">
						<div class="ttshop_singrights" >
							<div class="ttshop_singnav">
								<ul class="clearfloat">
									<li :class="{active: 0 == num}" class="liOne" @click="table(0)">账户登陆</li>
									<li :class="{active: 1 == num}" class="liTwo" @click="table(1)">短信登陆</li>
								</ul>
							</div>
							<div class="ttshop_singincon">
								<!-- 账户登陆 -->
								<div class="ttshop_singlist" v-show="num == 0">
									<!-- 错误提示 -->
									<div class="ttshop_singtop" :class="{ttshop_singtop_active:pwShow}">
										<p>
											<i>
												<img src="../../../assets/images/ttshop_samil.png" alt />
											</i>
											<span>{{pwTitle}}</span>
										</p>
									</div>
									<ul>
										<li>
											<input type="text" ref="name" v-model="name" placeholder="请输入手机号"  maxlength="11" class="ttshop_input" />
										</li>
										<li>
											<input type="password" ref="password" v-model="password" placeholder="请输入登录密码" class="ttshop_password" />
										</li>
										<li>
											<button class="ttshop_singbutton" @click="passwordLogin">登陆</button>
										</li>
										<div class="footer">服务热线：{{phone}}</div>
									</ul>
								</div>
								<!-- 短信登陆 -->
								<div class="ttshop_singlist" v-show="num == 1">
									<!-- 错误提示 -->
									<div class="ttshop_singtop" :class="{ttshop_singtop_active:iShow}">
										<p>
											<i>
												<img src="../../../assets/images/ttshop_samil.png" alt />
											</i>
											<span>{{title}}</span>
										</p>
									</div>
									<ul>
										<li>
											<input type="text" placeholder="手机号登陆" v-model="mobile" ref="mobile" maxlength="11" @blur="phoneQuery()" class="ttshop_input" />
										</li>
										<li>
											<input type="text" v-model="mobileCode" ref="mobileCode" placeholder="手机验证码" class="ttshop_mobileyz" />
											<template v-if="show">
												<div class="ttshop_yzm d-flex align-items-center justify-content-center" v-if="success" @click="getCode">获取验证码</div>
												<div class="ttshop_yzm d-flex align-items-center justify-content-center" v-else>获取验证码</div>
											</template>
											<template v-if="!show">
												<div class="ttshop_yzm d-flex align-items-center justify-content-center">{{count}}秒后重新发送</div>
											</template>
										</li>
										<div v-if="passwordShow && frame_list.length>0">
											<li>
											<template>
													<el-select v-model="id" class="true_select"
														@change="framewww"
														placeholder="请选择" >
														<el-option v-for="item in frame_list"
															:key="item.id"
															:label="item.name"
															:value="item.id">
														</el-option>
													</el-select>
											</template>
										</li>
										<!-- <li>
											<input type="password" placeholder="密码" v-model="reg_password" ref="reg_password"   class="ttshop_password" />
										</li> -->
										</div>
										
										<li>
											<button class="ttshop_singbutton" @click="codeLogin">登陆</button>
										</li>
										<div class="footer">服务热线：{{phone}}</div>
									</ul>
								</div>
							</div>
						</div>
					</div>
					<!-- 图片验证 -->
					<div class="ttshop_yanzheng" v-show="verify">
						<div class="ttshop_yanzhengbj"></div>
						<div class="ttshop_yanzhengbox">
							<slide-verify ref="slideblock" @success="onSuccess" @again="onAgain" @fulfilled="onFulfilled" @fail="onFail"
							 @refresh="onRefresh" :slider-text="text" :imgs="imgs" :accuracy="accuracy"></slide-verify>
							<div class="ttshop_yanzhengclose" @click="closeVerify">
								<img src="../../../assets/images/ttshop_colse.png" alt="">
							</div>
						</div>
					</div>
					
					
					
				</div>
			</div>
		</div>
			<!-- <Footer></Footer> -->
		<div class="footer-two" >
			<span >{{icp}}&nbsp;|&nbsp;{{isp}}</span>
			<span >:宏樾商城</span>
		</div>
		<div v-if="endtype==2" class="end_end">
			<el-dialog
				title=""
				:visible.sync="dialogVisible"
				width="20%"
				:modal-append-to-body="false"
				:show-close="false"
				center>
				<div slot="title" class="postion">
					<i class="el-icon-warning-outline"></i>
					<span class="download">提示</span>
				</div>
				<end></end>
				
			</el-dialog>
		</div>
	</div>
</template>

<script>
	import CryptoJS from 'crypto-js/crypto-js';
	import img0 from "../../../assets/images/img.jpg";
	import img1 from "../../../assets/images/img1.jpg";
	import img2 from "../../../assets/images/img2.jpg";
	import img3 from "../../../assets/images/img3.jpg";
	import img4 from "../../../assets/images/img4.jpg";
	import img5 from "../../../assets/images/img5.jpg";
	import end from './end.vue'
	import {
		Base64
	} from "js-base64";
	import md5 from "js-md5";
	export default {
		beforeCreate() {
		    document.querySelector('body').setAttribute('style', 'background:#F7F8FA');
		},
			components: {
			// Footer
			end
		},
		data() {
			return {
				dialogvisible:false,
				endtype:"3",
				passwordShow:false,
				route_url: this.$route.params.route_url,
				logo: "",  //登录logo
				logo_list: "",
				qycgtitle: '',
				phone: "",   //服务热线
				icp:"",//企业ICP-------
				isp:"",//企业ISP-------
				entrance: "",//入口列表
				num: 0,
				msg: "",
				text: "向右滑动->",
				imgs: [img0, img1, img2, img3, img4, img5],
				accuracy: 5, // 精确度小，可允许的误差范围小；为1时，则表示滑块要与凹槽完全重叠，才能验证成功。默认值为5
				verify: false,
				iShow: false,
				title: "",
				pwShow: false,
				pwTitle: "",
				mobile: "",
				mobileCode: "",
				show: true,
				success: false,
				timer: null,
				count: "",
				name: "",
				password: "",
				frame_list: [],
				// reg_password:"",
				id: '', //公司id
			}
		},
		watch: {
			$route(to, from) {
				//监听路由是否变化
				if (to.params.route_url != from.params.route_url) {
					this.route_url = to.params.route_url;
					this.checkEntrance();
				}
			},
		},
		created() {
			let that = this;
			this.route_url = this.$route.params.route_url;
			this.geturl();
			this.obtainlogo();
			this.getphone();
			document.onkeydown = function(e) {
				let key = window.event.keyCode;
				if (key === 13) {
					that.passwordLogin();
				}
			};
		},
		methods:{
			handleClose(){},
			// 验证url合法性
			geturl(){
				this.$api.qycgurl().then((res) => {
					if(res.code==0){
						this.endtype=1
						this.dialogVisible=false
					}else{
						this.endtype=2
						this.dialogVisible=true
					}
				}).catch((err) => {
					this.$router.replace(this.common.qycgrouter(this)+"/404");
				});
			},
			// 获取服务热线
			getphone(){
				this.$api.qycgphone({
					shop_type: 'qycg',
				}).then((res) => {
					this.phone = res.data.help.copyright.phone;
				}).catch((err) => {
					// this.common.message(this, err);
				});
			},
			framewww(id) {
      			this.id = id
    		},
			//手机号是否登录
			phoneQuery(){
				let _this = this;
				let num = _this.$refs.mobile.value;
				if (num == "") {
					_this.iShow = true;
					_this.title = "请输入手机号";
					return;
				}
				if (num.length == 11) {
					if (!/^1[3456789]\d{9}$/.test(num)) {
						_this.iShow = true;
						// _this.success = false;
						_this.title = "请输入正确手机号";
					
					} else {
						this.$api.phoneVrify({
							mobile: num,
						}).then((res) => {
							if(res.code==1){
								_this.passwordShow=false
								
							}else if(res.code==0){
								_this.passwordShow=true
								_this.frame_list=res.data
							}
							console.log(res,"1")
						}).catch((err) => {
					// this.common.message(this, err);
						});
						_this.iShow = false;
						_this.success = true;
					}
				} else {
					_this.iShow = true;
					_this.title = "请输入正确手机号";
				}
				
			},
			
			// 获取logo信息
			obtainlogo(){
				this.$api.qycglogo().then((res) => {
					this.logo_list = res.data;
					this.obtainlogodecode();
					// console.log(res)
				}).catch((err) => {
					// this.common.message(this, err);
				});
			},
			// 验证参数是否合规
			obtainlogodecode(){
				let that = this;
				// const key = CryptoJS.enc.Utf8.parse("sobMjJqgBhhCXFTi");
				const key = CryptoJS.enc.Utf8.parse("UDshDvooCKsnVCGO");
				let logo_list = this.logocode(this.logo_list,key);
			},
			logocode(word, keyStr) {
			    let base64 = CryptoJS.enc.Base64.parse(word);
			    let src = CryptoJS.enc.Base64.stringify(base64);
			    var decrypt = CryptoJS.AES.decrypt(src, keyStr, {
			        mode: CryptoJS.mode.ECB,
			        padding: CryptoJS.pad.Pkcs7
			    });
			    var decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
				decryptedStr = JSON.parse(decryptedStr);
				this.logo = decryptedStr.logo;
				let title = decryptedStr.title;
				this.qycgtitle = decryptedStr.title;
				this.icp=decryptedStr.icp
				this.isp=decryptedStr.isp
				// console.log(	decryptedStr )
				this.$store.commit("qycgTitle",title);
			    return decryptedStr.toString();
			},
			// 获取入口信息
			// verification(){
			// 	this.$api.qycgentrance({
			// 		shop_type: 'qycg',
			// 	}).then((res) => {
			// 		console.log(res)
			// 		this.entrance = res.data;
			// 		this.checkEntrance();
			// 		// console.log(res)
			// 	}).catch((err) => {
			// 		this.common.message(this, err);
			// 	});
			// },
			// 验证参数是否合规
			checkEntrance(){
				let that = this;
				// const key = CryptoJS.enc.Utf8.parse("sobMjJqgBhhCXFTi");
				const key = CryptoJS.enc.Utf8.parse("UDshDvooCKsnVCGO")
				let entrance = this.decrypt(this.entrance,key);
				if(entrance.indexOf(this.route_url) == -1){
					this.$message({
						showClose: true,
						message: "参数不合法",
						type: "warning",
						offset: 200,
						duration: 1000,
						onClose:function(){
							that.$router.replace("/");
						}
					});
				}
			},
			decrypt(word, keyStr) {
			    let base64 = CryptoJS.enc.Base64.parse(word);
			    let src = CryptoJS.enc.Base64.stringify(base64);
			    var decrypt = CryptoJS.AES.decrypt(src, keyStr, {
			        mode: CryptoJS.mode.ECB,
			        padding: CryptoJS.pad.Pkcs7
			    });
			    var decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
			    return decryptedStr.toString();
			},
		
			//账号密码登录
			passwordLogin() {
				let _this = this;
				let name = this.$refs.name.value;
				let password = this.$refs.password.value;
				if (name == "") {
					_this.pwTitle = "请输入用户名";
					_this.pwShow = true;
				} else if (password == "") {
					_this.pwTitle = "请输入密码";
					_this.pwShow = true;
				} else {
					_this.pwShow = false;
					_this.$api.qycglogin({
						mobile: name,
						password: password,
					}).then((res) => {
						if(res.code==0){
							this.$loading().close();
							this.$store.commit("qycgUserInfo", res.data);
							this.$store.commit("routeUrl",this.route_url);
							if(res.data.is_admin == 1){
								this.$router.replace(this.common.qycgrouter(this) + "/personal")
							}else{
								this.$router.replace(this.common.qycgrouter(this) + "/qycgindex");
							}
						}else{
							this.$message({
								showClose: true,
								message: res.msg,
								type: 'warning',
								offset: 200,
								duration: 1000
							});
						}
						
					}).catch((err) => {
						console.log(err);
						_this.pwTitle = err.msg;
						_this.pwShow = true;
					});
				}
			},
			// 获取验证码
			getCode() {
				if (this.success) {
					this.verify = true;
				} else {
					this.title = "请输入正确手机号";
					this.iShow = true;
				}
			},
			// 手机号失焦事件
			animateWidth() {
				let _this = this;
				let num = _this.$refs.mobile.value;
				if (num == "") {
					_this.iShow = false;
					return;
				}
				if (num.length == 11) {
					if (!/^1[3456789]\d{9}$/.test(num)) {reg_password
						_this.title = "请输入正确手机号";
						_this.iShow = true;
						_this.success = false;
					} else {
						_this.iShow = false;
						_this.success = true;
					}
				} else {
					_this.iShow = false;
				}
			},
			//获取验证码
			resSale() {
				let _this = this;
				let phone_number = _this.$refs.mobile.value;
				var time = Date.parse(new Date()) / 1000;
				this.dateFormat('y*m=dh&i#s', new Date());
				var date = _this.formatStr;
				var first = phone_number.substr(1, 4);
				var end = phone_number.substr(phone_number.length - 4);
				var sign = Base64.encode(md5(first + date + end + phone_number + time));
				_this.$api.qysale({
					mobile: phone_number,
					sign_time: time,
					sign: sign,
				}).then((res) => {
					_this.$api.qycode({
						mobile: phone_number,
						token: res.data.token,
					}).then((res) => {
						const TIME_COUNT = 60;
						if (!this.timer) {
							this.count = TIME_COUNT;
							this.show = false;
							this.timer = setInterval(() => {
								if (this.count > 0 && this.count <= TIME_COUNT) {
									this.count--;
								} else {
									this.show = true;
									clearInterval(this.timer);
									this.timer = null;
								}
							}, 1000);
						}
					}).catch((err) => {
						this.common.message(this, err);
					});
				}).catch((err) => {
					console.log(err);
				});
			},
			dateFormat(formatStr, fdate) {
				var fTime, fStr = 'ymdhis';
				if (!formatStr)
					formatStr = "y/m/d-h:i:s";
				if (fdate) {
					fTime = new Date(fdate);
				} else {
					fTime = new Date();
				}
				var formatArr = [
					fTime.getFullYear().toString(),
					(fTime.getMonth() + 1).toString() < 10 ? '0' + (fTime.getMonth() + 1).toString() : (fTime.getMonth() + 1).toString(),
					fTime.getDate().toString() < 10 ? '0' + fTime.getDate().toString() : fTime.getDate().toString(),
					fTime.getHours().toString() < 10 ? '0' + fTime.getHours().toString() : fTime.getHours().toString(),
					fTime.getMinutes().toString() < 10 ? '0' + fTime.getMinutes().toString() : fTime.getMinutes().toString(),
					fTime.getSeconds().toString() < 10 ? '0' + fTime.getSeconds().toString() : fTime.getSeconds().toString()
				];
				for (var i = 0; i < formatArr.length; i++) {
					formatStr = formatStr.replace(fStr.charAt(i), formatArr[i]);
				}
				this.formatStr = formatStr;
			},
			//验证码登录
			codeLogin() {
				let _this = this;
				let mobile = _this.$refs.mobile.value;
				let mobileCode = _this.$refs.mobileCode.value;
				if (mobile == "") {
					_this.title = "请输入手机号";
					_this.iShow = true;
				} else if (mobileCode = "") {
					_this.title = "请输入验证码";
					_this.iShow = true;
				} else {
					_this.iShow = false;
					_this.pcLogin();
				}
			},
			// 验证码密码登录切换
			table(index) {
				if (this.num != index) {
					this.num = index;
					this.mobile = "";
					this.mobileCode = "";
					// this.reg_password = "";
					this.subsidiary_id = "";
					this.passwordShow=false;
					this.name = "";
					this.password = "";
					this.iShow = false;
					this.pwShow = false;
				}
			},
			cancel: function() {
				// this.$router.replace(this.$route.query.redirect);
				this.$router.go(-1);
			},
			//关闭图形验证
			closeVerify() {
				this.verify = false;
			},
			// 图形验证
			onSuccess(times) {
				this.msg = `login success, 耗时${(times / 1000).toFixed(1)}s`;
				this.verify = false;
				this.resSale();
				this.handleClick();
			},
			onFail() {
				console.log("验证不通过");
				this.msg = "";
			},
			onRefresh() {
				console.log("点击了刷新小图标");
				this.msg = "";
			},
			onFulfilled() {
				console.log("刷新成功啦！");
			},
			onAgain() {
				console.log("检测到非人为操作的哦！");
				this.msg = "try again";
				// 刷新
				this.handleClick();
			},
			handleClick() {
				this.$refs.slideblock.reset();
				this.msg = "";
			},
			//验证码登录接口
			pcLogin() {
				let _this = this;
				_this.$api.qycglogin({
					mobile: _this.$refs.mobile.value,
					mobile_code: _this.$refs.mobileCode.value,
					subsidiary_id:_this.id,
					// reg_password:_this.reg_password
				}).then((res) => {
					if(res.code==0){
						this.$loading().close();
						this.$store.commit("qycgUserInfo", res.data);
						this.$store.commit("routeUrl",this.route_url);
						if(res.data.is_admin == 1){
							this.$router.replace(this.common.qycgrouter(this) + "/personal");
						}else{
							this.$router.replace(this.common.qycgrouter(this) + "/qycgindex");
						}
					}else{
						this.$message({
							showClose: true,
							message: res.msg,
							type: "warning",
							offset: 200,
							duration: 1000,
						});
					}
					
				}).catch((err) => {
					console.log(err);
					_this.title = err.msg;
					_this.iShow = true;
				});
			},
		},
	}
	
</script>

<style lang="scss" scoped>
	.log{
		background: url("../../../assets/purchase/image/login/login.jpg") no-repeat;
		background-size: 100% 100%;
		width:100%;
		height:100%;
		position:fixed;
			.footer-two{
					// margin: 0 auto;
					position: fixed;
					bottom: 0;
					left: 50%;
					bottom: 2%;
					// text-align: center;
					// height: 20px;
					// line-height: 20px;
					span{
						font-size: 12px;
						font-family: PingFangSC-Regular, PingFang SC;
						font-weight: 400;
						color: #666666;
						margin-right: 10px
					}
				}
		.login{
			margin: 0 auto;
			height: 100%;
			width:100%;
			position: absolute;
			.purchase{
					width: 100%;
					font-size: 32px;
					padding-bottom: 32px;
					font-weight: normal;
					color: #1D2129;
					top: 25%;
					left: 30%;
					position: absolute;
				}
			.login-top{
				width: 180px;
				height: 50px;
				position: absolute;
				top: 24px;
				left: 13%;
				
				img{
					width: 180px;
					height: 50px;
				}
			}
			.login-box{
				width:20%;
				position: absolute;
				right: 25%;
				top:25%;
				
				.footer{
					margin: 0 auto;
					margin-top: 18px;
					text-align: center;
					height: 20px;
					font-size: 14px;
					font-family: PingFangSC-Regular, PingFang SC;
					font-weight: 400;
					color: #8A9099;
					line-height: 20px;
				}
			
			}
		}
	}
	
	.ttshop_singtop_active {
		opacity: 1 !important;
	}
	.ttshop_singcon {
		width: 100%;
		.ttshop_singconter {
			background-position: left center;
			background-repeat: no-repeat;
			position: relative;
			.ttshop_singrights {
				width: 350px;
				height: 430px;
				background: #fff;
				// margin: 0 auto;
				// top:100px;
				border-radius: 10px;
				position: relative;
				.ttshop_singnav {
					width: 100%;
					height:52px ;
					// padding-top: 20px;
					// padding-left: 24px;
					box-sizing: border-box;
					position: relative;
					border-radius: 10px 16px 0 0 ;
					background:  #CC0000;
					ul {
						.liOne{
							border-radius: 0px 10px 0px 14px;
							
							&.active {
								color: #1D2129;
								background: #ffffff;
								border-radius: 7px 10px 0px 0px;
							}
	
							&.active:before {
								width: 100%;
							}
						}
						.liTwo{
							border-radius: 0px 10px 0px 14px;
							list-style: none;
							
							&.active {
								color: #1D2129;
								background: #ffffff;
								border-radius: 0px 10px 0px 14px;
								border-top-right-radius:10px;
							}
	
							&.active:before {
								width: 100%;
							}
						}
						li {
							// display: inline-block;
							width: 175px;
							list-style: none;
							height: 35px;
							text-align: center;
							float: left;
							padding-top: 15px;
							font-size: 16px;
							color: #FFFFFF;
							line-height: 16px;
							font-weight: 600;
							// border-radius: 0px 10px 0px 14px;
							// margin-right: 16px;
							cursor: pointer;
							transition: 0.5s;
							-moz-transition: 0.5s;
							-webkit-transition: 0.5s;
							-o-transition: 0.5s;
							position: relative;
	
							&:last-child {
								margin-right: 0;
							}
	
							&::before {
								content: "";
								width: 0%;
								height: 2px;
								background: #ff0e25;
								position: absolute;
								bottom: -2px;
								left: 50%;
								transform: translateX(-50%);
								-moz-transform: translateX(-50%);
								-webkit-transform: translateX(-50%);
								-o-transform: translateX(-50%);
								transition: 0.5s;
								-moz-transition: 0.5s;
								-webkit-transition: 0.5s;
								-o-transition: 0.5s;
							}
	
							&:hover {
								color: #ff0e25;
							}
	
							&:hover:before {
								width: 100%;
							}
	
						}
					}
	
					.ttshop_wx {
						width: 56px;
						height: 56px;
						position: absolute;
						top: 6px;
						right: 6px;
						cursor: pointer;
	
						img {
							display: block;
						}
					}
				}
	
				.ttshop_singincon {
					width: 100%;
					padding: 0 24px;
					box-sizing: border-box;
	
					.ttshop_singlist {
						width: 100%;
	
						.ttshop_singtop {
							width: 100%;
							height: 30px;
							background: #fff0f1;
							padding: 0 15px;
							line-height: 30px;
							margin: 8px 0;
							box-sizing: border-box;
							opacity: 0;
	
							p {
								i {
									display: inline-block;
									width: 12px;
									height: 12px;
									border-radius: 50%;
									margin-right: 6px;
									vertical-align: -2px;
	
									img {
										display: block;
										width: 100%;
										height: 100%;
										border-radius: 50%;
									}
								}
	
								span {
									font-size: 12px;
									color: #ff0e25;
								}
							}
						}
	
						ul {
							width: 100%;
	
							li {
								width: 100%;
								position: relative;
								margin-bottom: 20px;
								input {
									width: 100%;
									height: 40px;
									font-size: 12px;
									color: #333;
									padding: 0 41px;
									box-sizing: border-box;
									border: 1px solid #ebebeb;
									border-radius: 2px;
									outline: none;
									transition: 0.5s;
									-moz-transition: 0.5s;
									-webkit-transition: 0.5s;
									-o-transition: 0.5s;
	
									&:focus {
										border-color: #ff0e25;
									}
								}
	
								.ttshop_input {
									background: url(../../../assets/images/ttshop_mobiles.png) 10px center no-repeat;
								}
								.el-select {
									cursor: pointer;
									width: 100%;
								}
	
								.ttshop_mobileyz {
									padding-right: 110px;
									background: url(../../../assets/images/ttshop_yz.png) 11px center no-repeat;
								}
	
								.ttshop_password {
									background: url(../../../assets/images/ttshop_password.png) 11px center no-repeat;
								}
	
								.ttshop_yzm {
									// display: block;
									min-width: 98px;
									height: 38px;
									border: 0;
									outline: none;
									font-size: 12px;
									color: #333;
									border: 0;
									background: #eeeeee;
									position: absolute;
									top: 1px;
									right: 1px;
									border-radius: 0 2px 2px 0;
									cursor: pointer;
								}
	
								p {
									display: table;
									font-size: 12px;
									color: #666;
									transition: 0.5s;
									-moz-transition: 0.5s;
									-webkit-transition: 0.5s;
									-o-transition: 0.5s;
									cursor: pointer;
	
									&:hover {
										color: #ff0e25;
									}
								}
	
								.ttshop_singbutton {
									width: 100%;
									height: 40px;
									font-size: 14px;
									color: #fff;
									border: 0;
									outline: none;
									border-radius: 2px;
									cursor: pointer;
									background: linear-gradient(360deg, #CC0000 0%, #E0251B 100%);
									background: -moz-linear-gradient(360deg, #CC0000 0%, #E0251B 100%);
									background: -webkit-gradient(360deg, #CC0000 0%, #E0251B 100%);
									background: -ms-linear-gradient(360deg, #CC0000 0%, #E0251B 100%);
									filter: progid:DXImageTransform.Microsoft.gradient(GradientType=1, startColorstr=#FF9010, endColorstr=#FF0E25);
									transition: 0.5s;
									-moz-transition: 0.5s;
									-webkit-transition: 0.5s;
									-o-transition: 0.5s;
	
									&:hover {
										box-shadow: 0 5px 10px rgba(215, 119, 8, 0.5);
									}
								}
	
								a {
									font-size: 12px;
									color: #ff0e25;
									display: table;
									margin: 0 auto;
									text-align: center;
								}
							}
	
							.ttshop_forget {
								margin-bottom: 16px;
							}
						}
					}
				}
	
				// 二维码登录
				.ttshop_scan {
					width: 100%;
					padding-left: 24px;
					padding-top: 32px;
					box-sizing: border-box;
					margin-bottom:30px;
	
					p {
						font-size: 16px;
						color: #666;
						font-weight: 600;
						line-height: 16px;
					}
				}
	
				.ttshop_codeimg {
					width: 170px;
					height: 170px;
					background: #fff;
					border-radius: 4px;
					box-shadow: 0px 0px 20px 0px rgba(36, 37, 39, 0.12);
					margin: 0 auto 40px;
					padding: 14px;
					box-sizing: border-box;
	
					img {
						display: block;
						width: 142px;
						height: 142px;
					}
				}
	
				.ttshop_codetext {
					width: 100%;
					padding: 0 24px;
					box-sizing: border-box;
	
					p {
						font-size: 12px;
						color: #666;
						text-align: center;
						font-weight: 400;
						line-height: 18px;
					}
				}
	
				.ttshop_wxer {
					width: 56px;
					height: 56px;
					position: absolute;
					top: 6px;
					right: 6px;
					cursor: pointer;
	
					img {
						display: block;
					}
				}
			}
		}
	
		.ttshop_yanzheng {
			width: 100%;
			height: 100%;
			position: fixed;
			top: 0;
			left: 0;
			z-index: 1000;
	
			.ttshop_yanzhengbj {
				width: 100%;
				height: 100%;
				position: fixed;
				top: 0;
				left: 0;
				background: rgba(0, 0, 0, 0.4);
			}
	
			.ttshop_yanzhengbox {
				position: fixed;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
				padding: 20px;
				box-sizing: border-box;
				background: #fff;
				border-radius: 8px;
	
				.ttshop_yanzhengclose {
					height: 12px;
					width: 12px;
					position: absolute;
					top: 5px;
					right: 5px;
					cursor: pointer;
				}
			}
		}
	}
	.end_end{
		// position: absolute;
		// top: 24px;
    	// left: 13%;
		// z-index: 999999;
		i{
			color:red;
			font-size: 20px;
			margin-right:5px
		}
		.download{
			font-size: 20px;
		}
	}
	
	
</style>
